import { useEffect, useState } from "react"
import type { SuccessFetch } from "types"
import { useApi } from "utils"
import { DataList } from "../types"

export function useList(product_id: number,dateFrom:string, dateEnd:string) {
  const api = useApi()
  const [data, setData] = useState<DataList[]>([])
  const [isLoading, setLoading] = useState(false)

  const params = {
    date_from: dateFrom,
    date_end: dateEnd,
  }


  useEffect(() => {
    setLoading(true)

    api.get(`/product/transaction/sales/${product_id}`,{params}) 
    .then((res: SuccessFetch<{ payload: DataList[] }>) => setData(res.data.payload))
    .catch(() => setData([]) )
    .finally(() => setLoading(false))
  
    return () => {
      setData([])
      setLoading(true)
    }
      // eslint-disable-next-line
    }, [dateFrom, dateEnd])

  return { data, isLoading }
}